<template>
  <v-chip label class="squeeze mr-1" :color="iconColor" small @click.stop="clicked">
    <span v-if="isFilm">
      <v-img v-if="image" :src="image" width=48></v-img>
      <v-icon v-else>{{ icon }}</v-icon>
    </span>
    <v-avatar v-else>
      <v-img v-if="image" :src="image"></v-img>
      <v-icon v-else>{{ icon }}</v-icon>
    </v-avatar>
    <span :class="textSizeClass">
      &nbsp;{{ text }}
    </span>
  </v-chip>
</template>
<script>
import { getIcon, getIconColor, settings } from '@/js/store'
import { SearchUtils } from '@/js'
export default {
  props: {
    itemReason: {
      type: Object,
      required: true
    },
    clickit: {
      type: String
    }
  },
  methods: {
    clicked () {
      if (this.clickit) this.$emit(this.clickit)
    }
  },
  computed: {
    textSizeClass () {
      return this.$vuetify.breakpoint.smAndUp ? 'caption' : 'fid-xs-small-text'
    },
    isFilm () {
      return this.itemType === 'film' || this.itemType === 'vimeofilm'
    },
    image () {
      return this.itemType && SearchUtils.getImageFromReason({
        reason: this.itemReason,
        minHeight: settings.dimensions.posterFrameHeight
      })
    },
    text () {
      return this.itemType && SearchUtils.getBigTextFromReason({ reason: this.itemReason })
    },
    itemType () {
      return this.itemReason && this.itemReason.matchType
    },
    icon () {
      return this.itemType && getIcon(this.itemType)
    },
    iconColor () {
      return this.itemType && getIconColor(this.itemType)
    }
  }
}
</script>
